import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { MDBContainer, MDBRow, MDBCol, MDBSpinner } from 'mdb-react-ui-kit'
import ContentHtmlCard from './../../../../components/content/ContentHtmlCard/ContentHtmlCard.component'
import { renderVideo } from '../../../../components/content/ContentVideo/renderVideo'
import TrainingValidator from '../../../TrainingPages/components/TrainingValidator/TrainingValidator.component'
import TrainingQuiz from '../../../TrainingPages/components/TrainingQuiz/TrainingQuiz.component'
import TrainingQuizService from '../../../../shared/services/TrainingQuiz.service'
import TrainingQuestionService from '../../../../shared/services/TrainingQuestion.service'
import TrainingAnswerService from '../../../../shared/services/TrainingAnswer.service'
import AdminApi from '../../../../api/admin-api/admin-api'

const USE_INTRO_CONTENT = false

const AgentWelcomeIntro = ({ isAffiliateAgent, isAssociateAgent, isSignatureAgent, isCareerAgent, video, init }) => {
  const [stepsContentID, setStepsContentID] = useState(null)
  const [introContentID, setIntroContentID] = useState(null)
  const [quizData, setQuizData] = useState(null)
  const [quizLoading, setQuizLoading] = useState(false)

  useEffect(() => {
    const getSlugByAgent = typeMap => {
      if (isAffiliateAgent) return typeMap.affiliate
      if (isAssociateAgent) return typeMap.associate
      if (isSignatureAgent) return typeMap.signature
      if (isCareerAgent) return typeMap.career
      return null
    }

    const fetchContentIdBySlug = async (slug, setter) => {
      if (!slug) return
      try {
        const response = await AdminApi.getAgencyContentBySlug({ slug })
        const content = response?.data?.data?.shift()
        if (content?.id) {
          setter(content.id)
        }
      } catch (ex) {
        console.error(`Failed to fetch content for slug "${slug}":`, ex)
      }
    }

    fetchContentIdBySlug(
      getSlugByAgent({
        affiliate: 'affiliate-getting-started',
        associate: 'associate-getting-started',
        signature: 'signature-getting-started',
        career: 'career-getting-started',
      }),
      setStepsContentID
    )

    fetchContentIdBySlug(
      getSlugByAgent({
        affiliate: 'affiliate-welcome-intro',
        associate: 'associate-welcome-intro',
        signature: 'signature-welcome-intro',
        career: 'career-welcome-intro',
      }),
      setIntroContentID
    )
  }, [isAffiliateAgent, isAssociateAgent, isSignatureAgent, isCareerAgent])

  useEffect(() => {
    const fetchQuizData = async () => {
      if (!video?.requires_quiz) return
      setQuizLoading(true)
      try {
        const training_quiz = (
          await TrainingQuizService.search({
            search: { training_id: video.id },
          })
        )?.models[0]
        const training_questions =
          (
            await TrainingQuestionService.search({
              search: { quiz_id: training_quiz?.id },
            })
          )?.models || []
        const question_ids = training_questions.map(q => q.id)
        const training_answers =
          (
            await TrainingAnswerService.search({
              search: {
                question_id: question_ids?.length > 0 ? question_ids : null,
              },
            })
          )?.models || []
        setQuizData({ training_quiz, training_questions, training_answers })
      } catch (ex) {
        console.error('Failed to fetch quiz data', ex)
      }
      setQuizLoading(false)
    }
    fetchQuizData()
  }, [video])

  if (!video) return <></>
  return (
    <main id='AgentWelcomeIntroPage' className='mainSection'>
      <MDBContainer>
        {USE_INTRO_CONTENT ? (
          <MDBRow>
            <MDBCol
              size='12'
              sm={video ? '4' : '0'}
              md={video ? '4' : '0'}
              lg={video ? '4' : '0'}
              className='video-wrapper'
            >
              {renderVideo(video.training_link, video.training_name)}
            </MDBCol>
            <MDBCol size={video ? '8' : '12'}>
              <ContentHtmlCard contentId={introContentID} fullHeight />
            </MDBCol>
          </MDBRow>
        ) : (
          <MDBRow>
            <MDBCol size='12' md='8' xl='10' className='video-wrapper offset-md-2 offset-xl-1'>
              {renderVideo(video.training_link, video.training_name)}
            </MDBCol>
          </MDBRow>
        )}
        {video?.requires_quiz && !video.hasCompleted?.current ? (
          <div className='my-4'>
            {quizLoading ? (
              <div className='text-center'>
                <MDBSpinner />
              </div>
            ) : quizData ? (
              <TrainingQuiz
                training_quiz={quizData.training_quiz}
                training_questions={quizData.training_questions}
                training_answers={quizData.training_answers}
                onSuccess={init}
              />
            ) : null}
          </div>
        ) : video && video.training_code && !video.hasCompleted?.current ? (
          <div className='my-4'>
            <TrainingValidator trainings={video ? [video] : []} onSuccess={init} isOnboarding={true} />
          </div>
        ) : null}
        <br />
        <MDBRow>
          <MDBCol size='12'>
            <ContentHtmlCard contentId={stepsContentID} />
          </MDBCol>
        </MDBRow>
        <br />
      </MDBContainer>
    </main>
  )
}

export default observer(AgentWelcomeIntro)
